var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 255,
    viewBox: "0 0 160 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.886 216.566C125.15 215.2 131.22 213.061 136.958 210.201",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.017 215.405C63.9931 220.318 89.4066 221.552 110.633 218.172",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.288 168.112C5.77699 172.751 1.728 178.793 1.728 186.466C1.728 198.075 15.209 207.224 34.144 213.025",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.686 128.233C11.682 133.969 5.639 141.044 5.792 148.991C6.147 167.821 37.33 187.087 75.7482 187.087C97.9265 187.087 116.03 182.714 116.345 170.226C116.66 157.737 88.9954 155.599 71.0608 155.236C52.505 154.856 30.924 157.696 16.838 165.296",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.554 135.356C60.841 136.759 69.2176 137.568 77.6201 137.777C97.9347 138.269 130.714 133.743 129.77 124.352C128.826 114.961 97.2974 112.791 75.7162 112.791C54.135 112.791 41.832 115.824 26.995 123.408",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.637 94.2271C16.688 96.107 15.13 98.3533 14.051 100.837C12.973 103.321 12.395 105.993 12.352 108.701C12.159 121.754 26.648 129.427 43.816 133.582",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.264 79.8988C102.268 77.6479 88.0605 76.6717 73.2482 77.4785C55.418 78.4466 34.765 81.9965 22.809 89.6608",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.385 98.7369C122.017 95.8003 126.487 91.8713 126.341 88.0876C126.245 85.7802 123.768 83.7472 119.589 82.0852",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.51 49.5964C11.9 55.2923 3.29201 63.9006 3.29201 73.4124C3.29201 94.0255 57.628 103.077 84.1791 103.392C92.0703 103.544 99.9486 102.69 107.624 100.851",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6904 39.7295C57.894 40.149 43.469 42.529 31.65 46.5871",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.32 29.6929C30.609 37.0507 25.89 42.4883 26.091 46.2398C26.583 55.55 64.3403 63.3031 91.3592 61.5685C110.02 60.3584 124.776 56.8812 125.09 49.0797C125.373 42.0365 99.5076 39.8341 80.6694 39.6808",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.213 226.425C121.558 226.425 115.353 220.104 115.353 212.307C115.353 204.509 121.558 198.188 129.213 198.188C136.868 198.188 143.073 204.509 143.073 212.307C143.073 220.104 136.868 226.425 129.213 226.425Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.293 107.135C117.638 107.135 111.433 100.814 111.433 93.0167C111.433 85.2193 117.638 78.8982 125.293 78.8982C132.948 78.8982 139.153 85.2193 139.153 93.0167C139.153 100.814 132.948 107.135 125.293 107.135Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.916 229.87C45.261 229.87 39.056 223.549 39.056 215.751C39.056 207.954 45.261 201.633 52.916 201.633C60.5707 201.633 66.7764 207.954 66.7764 215.751C66.7764 223.549 60.5707 229.87 52.916 229.87Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5256 149.765C54.871 149.765 48.665 143.444 48.665 135.647C48.665 127.849 54.871 121.528 62.5256 121.528C70.1805 121.528 76.3857 127.849 76.3857 135.647C76.3857 143.444 70.1805 149.765 62.5256 149.765Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6252 53.2671C82.9703 53.2671 76.7647 46.946 76.7647 39.1486C76.7647 31.3511 82.9703 25.03 90.6252 25.03C98.2801 25.03 104.485 31.3511 104.485 39.1486C104.485 46.946 98.2801 53.2671 90.6252 53.2671Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.285 44.6895L85.065 34.7695H86.585L88.185 42.5895L89.785 34.7695H91.465L93.065 42.5895L94.665 34.7695H96.185L93.965 44.6895H92.245L90.625 36.7295L89.005 44.6895H87.285Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.423 87.0769V85.1369H126.323V87.0769H124.423ZM121.243 98.7369V97.3569H124.583V90.1969H121.743V88.8169H126.183V97.3569H129.343V98.7369H121.243Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2654 140.747V130.827H59.8654V132.587C60.6054 131.347 61.8854 130.547 63.3054 130.547C65.2054 130.547 66.7854 131.647 66.7854 134.007V140.747H65.1854V134.427C65.1854 132.847 64.2054 132.007 62.7854 132.007C61.2454 132.007 59.8654 133.407 59.8654 135.327V140.747H58.2654Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8788 221.631C49.1988 221.631 47.2388 219.471 47.2388 216.391C47.2388 213.311 49.1588 211.151 51.7388 211.151C53.2988 211.151 54.5188 211.891 55.2388 213.051V207.351H56.8588V221.351H55.2388V219.671C54.6788 220.711 53.4788 221.631 51.8788 221.631ZM52.1388 220.171C54.0788 220.171 55.3788 218.571 55.3788 216.391C55.3788 214.211 54.0388 212.611 52.1388 212.611C50.2188 212.611 48.8988 214.171 48.8988 216.391C48.8988 218.611 50.1988 220.171 52.1388 220.171Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.04 221.471C126.34 221.471 125.84 221.291 125.38 221.031L125.86 219.651C126.14 219.811 126.56 219.991 127.02 219.991C127.58 219.991 128.06 219.691 128.34 218.971L129.04 217.231L124.76 207.351H126.56L129.86 215.171L133.08 207.351H134.82L129.74 219.471C129.14 220.871 128.28 221.471 127.04 221.471Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindy);
export default __webpack_public_path__ + "static/media/windy.553a025eaf9edcafa095e0eb5ac3f9d2.svg";
export { ForwardRef as ReactComponent };